/**
 * Unified Deals API client.
 *
 * Backs the company-grouped /deals page (the "what's becoming real?"
 * surface). Calls GET /api/v1/deals/by-company.
 */
import api from './api';

export interface DealsInvestorSub {
  pipeline_id: number;
  stage: string | null;
  match_id: number | null;
  brief_id: number | null;
  investor_id: number | null;
  investor_name: string | null;
  firm_name: string | null;
  updated_at: string | null;
  stage_entered_at: string | null;
}

export interface DealsEntity {
  kind: 'company' | 'project';
  entity_id: number;
  entity_name: string;
  industry?: string | null;
  funding_stage?: string | null;
  deal_room_id?: number | null;
  investors: DealsInvestorSub[];
  stage_summary: Record<string, number>;
  investor_count: number;
}

export interface DealsByCompanyPayload {
  companies: DealsEntity[];
  projects: DealsEntity[];
  total_pipelines: number;
}

const dealsService = {
  async fetchByCompany(includePassed = false): Promise<DealsByCompanyPayload> {
    const resp = await api.get('/deals/by-company', {
      params: { include_passed: includePassed },
    });
    return resp.data as DealsByCompanyPayload;
  },
};

export default dealsService;
